import { render, staticRenderFns } from "./CreateServerV2.vue?vue&type=template&id=680bd8e9&scoped=true"
import script from "./CreateServerV2.vue?vue&type=script&lang=js"
export * from "./CreateServerV2.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreateServerV2.vue?vue&type=style&index=1&id=680bd8e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680bd8e9",
  null
  
)

export default component.exports